export enum MediaEvents {
    // The element is no longer paused. Fired after the play() method has returned, or when the autoplay attribute has caused playback to begin.
    play  = 'play',
    // The element has been paused. Fired after the pause() method has returned.
    pause = 'pause',
    // Playback has stopped because the end of the media resource was reached.
    ended = 'ended',
    // An error occurs while fetching the media data or the type of the resource is not supported media format.
    error = 'error',

    videoReady =  'videoReady'
}
